export const VisibleSeoContent: React.FC = () => {
  return (
    <div className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* セクション0: ゲームルール詳解 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            4文字日本語Wordleの遊び方
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-blue-200 dark:border-blue-800">
              <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-4">
                基本ルール
              </h3>
              <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">
                言葉で遊ぼうは、ひらがな4文字の今日の単語を当てる無料の日本語Wordleです。入力するたびに色ヒントが返り、残り候補を少しずつ絞ります。
              </p>
              <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-3">
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 dark:text-blue-400 font-bold">
                    •
                  </span>
                  <span>
                    <strong>毎日1つの新しい単語</strong>を当てる
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 dark:text-blue-400 font-bold">
                    •
                  </span>
                  <span>
                    <strong>最大12回</strong>の試行が可能
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 dark:text-blue-400 font-bold">
                    •
                  </span>
                  <span>短い時間でも1回分の問題に取り組める</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 dark:text-blue-400 font-bold">
                    •
                  </span>
                  <span>
                    <strong>ひらがな4文字</strong>の単語を入力
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-blue-600 dark:text-blue-400 font-bold">
                    •
                  </span>
                  <span>タイムゾーン設定に応じて新しい問題へ切り替わる</span>
                </li>
              </ul>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-green-200 dark:border-green-800">
              <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-4">
                🎨 色の意味
              </h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-500 rounded"></div>
                  <div>
                    <p className="font-semibold text-gray-900 dark:text-white">
                      緑
                    </p>
                    <p className="text-xs text-gray-600 dark:text-gray-400">
                      正しい位置に正しい文字
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-yellow-500 rounded"></div>
                  <div>
                    <p className="font-semibold text-gray-900 dark:text-white">
                      黄
                    </p>
                    <p className="text-xs text-gray-600 dark:text-gray-400">
                      単語に含まれるが位置違い
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gray-400 rounded"></div>
                  <div>
                    <p className="font-semibold text-gray-900 dark:text-white">
                      灰
                    </p>
                    <p className="text-xs text-gray-600 dark:text-gray-400">
                      単語に含まれない文字
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-emerald-200 dark:border-emerald-800 mb-6">
            <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-4">
              初手と候補整理のコツ
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-700 dark:text-gray-300">
                <thead className="text-gray-900 dark:text-white">
                  <tr>
                    <th className="py-2 pr-4">場面</th>
                    <th className="py-2 pr-4">見るポイント</th>
                    <th className="py-2">次の動き</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t border-gray-200 dark:border-gray-700">
                    <td className="py-2 pr-4">1手目</td>
                    <td className="py-2 pr-4">
                      重複が少なく母音を広く試せるか
                    </td>
                    <td className="py-2">当てに行くより情報量を優先する</td>
                  </tr>
                  <tr className="border-t border-gray-200 dark:border-gray-700">
                    <td className="py-2 pr-4">黄色が出た</td>
                    <td className="py-2 pr-4">同じ位置で再入力していないか</td>
                    <td className="py-2">別の位置へ移して候補を試す</td>
                  </tr>
                  <tr className="border-t border-gray-200 dark:border-gray-700">
                    <td className="py-2 pr-4">灰色が多い</td>
                    <td className="py-2 pr-4">使えるかなと母音の組み合わせ</td>
                    <td className="py-2">未使用の頻出かなを入れる</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-gray-800 dark:to-gray-700 rounded-lg p-6 border border-purple-200 dark:border-purple-800 mb-6">
            <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-4">
              ⚙️ ゲームモード
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <p className="font-semibold text-gray-900 dark:text-white mb-2">
                  通常モード
                </p>
                <p className="text-sm text-gray-700 dark:text-gray-300">
                  基本的なルールで、判明した情報を自由に使って遊べます。
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-900 dark:text-white mb-2">
                  ハードモード
                </p>
                <p className="text-sm text-gray-700 dark:text-gray-300">
                  前の推測で判明した文字を必ず使う必要があります。
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-900 dark:text-white mb-2">
                  ヒントモード
                </p>
                <p className="text-sm text-gray-700 dark:text-gray-300">
                  かなの行や段など、追加の手掛かりが表示されます。
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-900 dark:text-white mb-2">
                  高コントラストモード
                </p>
                <p className="text-sm text-gray-700 dark:text-gray-300">
                  色の違いを見分けやすくする表示設定です。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* セクション1: 語彙練習 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            日本語学習と語彙練習への使い方
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-green-200 dark:border-green-800">
              <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-4">
                まず始めるとき
              </h3>
              <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                <li>• 基本的な単語を繰り返し読む</li>
                <li>• ひらがな・カタカナの入力に慣れる</li>
                <li>• 色ヒントの意味を覚える</li>
                <li>• 分からなかった単語を短く復習する</li>
              </ul>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-blue-200 dark:border-blue-800">
              <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-4">
                続けて遊ぶとき
              </h3>
              <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                <li>• 既習語彙をゲーム内で思い出す</li>
                <li>• 4文字・5文字の違いを整理する</li>
                <li>• 初手と候補整理の方針を試す</li>
                <li>• 文法や会話教材と組み合わせる</li>
              </ul>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-purple-200 dark:border-purple-800">
              <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-4">
                ほかの教材と組み合わせるとき
              </h3>
              <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                <li>• 継続的な語彙復習の習慣を作る</li>
                <li>• 苦手なかなや音を記録する</li>
                <li>• 長い単語リストを用途別に整理する</li>
                <li>• 他の教材で意味と用法を確認する</li>
              </ul>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-orange-200 dark:border-orange-800">
              <h3 className="font-semibold text-lg text-gray-900 dark:text-white mb-4">
                プレイ後の復習
              </h3>
              <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                <li>• 短時間の学習習慣を作る</li>
                <li>• 見た単語をもう一度思い出す</li>
                <li>• 推理の手順を振り返る</li>
                <li>• 自分のペースで継続する</li>
              </ul>
            </div>
          </div>
        </section>

        {/* セクション2: 単語分類 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            4文字単語の分類
          </h2>
          <div className="grid md:grid-cols-3 gap-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border-l-4 border-green-500">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
                名詞（めいし）
              </h3>
              <p className="text-sm text-gray-700 dark:text-gray-300">
                人、物、場所などを表す言葉です。読み方と意味を一緒に確認します。
              </p>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border-l-4 border-blue-500">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
                動詞（どうし）
              </h3>
              <p className="text-sm text-gray-700 dark:text-gray-300">
                行動や状態を表す言葉です。辞書で基本形を確認すると復習しやすくなります。
              </p>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border-l-4 border-purple-500">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
                形容詞（けいようし）
              </h3>
              <p className="text-sm text-gray-700 dark:text-gray-300">
                性質や状態を表す言葉です。似た意味の単語と一緒に覚えると便利です。
              </p>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border-l-4 border-yellow-500">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
                副詞（ふくし）
              </h3>
              <p className="text-sm text-gray-700 dark:text-gray-300">
                動詞や形容詞を修飾する言葉です。例文で使い方を確認できます。
              </p>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border-l-4 border-red-500">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
                外来語（がいらいご）
              </h3>
              <p className="text-sm text-gray-700 dark:text-gray-300">
                外国語から取り入れた言葉です。カタカナで出題される場合もあります。
              </p>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border-l-4 border-indigo-500">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
                代名詞（だいめいし）
              </h3>
              <p className="text-sm text-gray-700 dark:text-gray-300">
                名詞の代わりに使う言葉です。意味や使われる場面を確認します。
              </p>
            </div>
          </div>
        </section>

        {/* セクション3: よくある質問 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            よくある質問
          </h2>
          <div className="space-y-4">
            <details className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
              <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                言葉で遊ぼうは4文字の日本語Wordleですか？
              </summary>
              <p className="text-sm text-gray-700 dark:text-gray-300 mt-3">
                はい。言葉で遊ぼう（ことばであそぼう）は、ひらがな4文字の単語を12回以内に当てる無料の日本語Wordleゲームです。毎日新しい問題に挑戦できます。
              </p>
            </details>

            <details className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
              <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                ことばであそぼうと検索しても同じゲームですか？
              </summary>
              <p className="text-sm text-gray-700 dark:text-gray-300 mt-3">
                はい。「言葉で遊ぼう」と「ことばであそぼう」は同じゲームを指します。漢字表記でもひらがな表記でも、4文字の日本語Wordleとして遊べます。
              </p>
            </details>

            <details className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
              <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                毎日何時に新しい単語が出現しますか？
              </summary>
              <p className="text-sm text-gray-700 dark:text-gray-300 mt-3">
                保存したタイムゾーンの日付に合わせて、新しい問題へ切り替わります。設定画面で地域を変更できます。
              </p>
            </details>

            <details className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
              <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                初心者でも楽しめますか？
              </summary>
              <p className="text-sm text-gray-700 dark:text-gray-300 mt-3">
                もちろんです。ヒントモードを使えば、色や単語の意味を確認しながら始められます。語彙や会話力の伸び方には個人差があるため、このゲームだけで学習期間や到達レベルを保証するものではありません。
              </p>
            </details>

            <details className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
              <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                どのくらいの期間で日本語が話せるようになりますか？
              </summary>
              <p className="text-sm text-gray-700 dark:text-gray-300 mt-3">
                このゲームは単語と推理の練習を補助するものです。会話ができるようになるまでの期間や到達レベルは、学習内容と個人差によって異なります。
              </p>
            </details>

            <details className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
              <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                過去のゲームをプレイできますか？
              </summary>
              <p className="text-sm text-gray-700 dark:text-gray-300 mt-3">
                はい、カレンダー機能で過去のゲームをプレイできます。学習の復習に活用できます。
              </p>
            </details>

            <details className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
              <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                wordle 日本語 4文字を探している場合、このページで遊べますか？
              </summary>
              <p className="text-sm text-gray-700 dark:text-gray-300 mt-3">
                はい。このページは、ひらがな4文字の単語を当てる日本語版Wordleとして遊べます。ローマ字入力にも対応しているため、日本語キーボードがなくても挑戦できます。
              </p>
            </details>

            <details className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
              <summary className="font-semibold text-gray-900 dark:text-white cursor-pointer">
                ことのはたんごの前に練習できますか？
              </summary>
              <p className="text-sm text-gray-700 dark:text-gray-300 mt-3">
                できます。4文字盤面は短いので、緑を固定する、黄色を別位置へ動かす、灰色を除外するという基本を練習しやすく、5文字の日本語Wordleへ進む前の準備になります。
              </p>
            </details>
          </div>
        </section>

        {/* セクション4: 学習のコツ */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            💡 効果的な学習のコツ
          </h2>
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-700 rounded-lg p-6 border border-green-200 dark:border-green-800">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">
                  毎日の学習習慣
                </h3>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                  <li>✓ 続けやすい時間にプレイ</li>
                  <li>✓ 分からない単語を記録する</li>
                  <li>✓ 無理のない範囲で復習する</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">
                  条件を変えて練習
                </h3>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                  <li>✓ 通常モードでルールを確認</li>
                  <li>✓ ヒントモードでかなの手掛かりを試す</li>
                  <li>✓ 慣れたらハードモードに挑戦</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">
                  復習と定着
                </h3>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                  <li>✓ 過去のゲームを復習</li>
                  <li>✓ 統計情報の確認</li>
                  <li>✓ 新しい単語の使用</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">
                  モチベーション維持
                </h3>
                <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                  <li>✓ 具体的な目標設定</li>
                  <li>✓ 友人との競争</li>
                  <li>✓ 成果の可視化</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
